"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShouldUsePreviewSize = void 0;

var getShouldUsePreviewSize = function getShouldUsePreviewSize(image) {
  return image.get('height') <= image.get('width');
};

exports.getShouldUsePreviewSize = getShouldUsePreviewSize;